import { render, staticRenderFns } from "./UploadsItem.vue?vue&type=template&id=15553b8e&scoped=true"
import script from "./UploadsItem.vue?vue&type=script&lang=js"
export * from "./UploadsItem.vue?vue&type=script&lang=js"
import style0 from "./UploadsItem.vue?vue&type=style&index=0&id=15553b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15553b8e",
  null
  
)

export default component.exports